const PORTRAIT_RATIO_MAX = 0.9
const LANDSCAPE_RATIO_MIN = 1.1

export function resolveAnnotationMediaLayout(widthValue, heightValue) {
  const width = Number(widthValue)
  const height = Number(heightValue)
  if (![width, height].every(value => Number.isFinite(value) && value > 0)) return null

  const ratio = width / height
  return {
    width,
    height,
    ratio,
    orientation: ratio < PORTRAIT_RATIO_MAX
      ? 'portrait'
      : ratio > LANDSCAPE_RATIO_MIN ? 'landscape' : 'square'
  }
}

export function readAnnotationMediaLayout(media) {
  if (!media) return null
  return resolveAnnotationMediaLayout(
    media.videoWidth || media.naturalWidth,
    media.videoHeight || media.naturalHeight
  )
}
